import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import Select, { components } from "react-select";
import {
  Select as AntSelect,
  Dropdown,
  Input as AntdInput,
  Menu,
  Checkbox,
  Tag,
  TimePicker,
  DatePicker,
} from "antd";
// import { fieldContainsValue } from "../controllers/";i
import { fieldContainsValue, universalSortForObjectsArray } from "../../../controllers/common";
import { SvgIcon } from "../Svg";

import { DownOutlined } from "@ant-design/icons";
import { Eye, EyeOff } from "lucide-react";
import { CloseCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import classNames from "classnames";
dayjs.extend(customParseFormat);
// import { height } from 'pdfkit/js/page'
const { Option } = Select;

export const Input = ({
  oneTimeEditMode,
  allTimeEditMode,
  type,
  mandatory = false,
  required = false,
  placeholder,
  value,
  updatedValue,
  onChange = () => {},
  title,
  name,
  className,
  disabled = false,
  autoFocus,
  error,
  onBlur = () => {},
  min,
  step,
  style,
  max,
  maxLength,
  titleSvgType, // type string
  titleSvgSize, // type number
  onTitleSvgClick, // type function
  capitalizeValue = false, // to enable onaccepting capitalize value
  autoComplete = "off",
}) => {
  return (
    <div className={``}>
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C]  flex  flex items-center justify-between gap-0">
          <span>
            {title}
            {mandatory && <span className="p-0 m-0 text-sm">*</span>}
          </span>
          {titleSvgType && (
            <span
              style={{
                ...(onTitleSvgClick && {
                  cursor: "pointer",
                }),
              }}
              onClick={() => {
                if (onTitleSvgClick) {
                  onTitleSvgClick();
                }
              }}
            >
              <SvgIcon size={titleSvgSize} type={titleSvgType} />
            </span>
          )}
        </h3>
      )}
      <input
        maxLength={maxLength}
        max={max}
        autoFocus={autoFocus}
        type={type}
        name={name}
        className={`pl-[11px] h-[38px] ${
          required ? "border-red-500" : ""
        } form-input p-1 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 ${className}`}
        placeholder={placeholder}
        value={value}
        // onChange={onChange}
        onChange={(e) => {
          if (maxLength && e.target?.value?.length > maxLength) {
            return 0;
          }
          if (capitalizeValue) {
            e.target.value = e?.target?.value?.toUpperCase();
          }
          onChange(e);
        }}
        onBlur={onBlur}
        disabled={disabled}
        style={{
          ...(disabled && {
            cursor: "not-allowed",
            backgroundColor: "var(--input-disabled-bg)",
            color: "black",
          }),
          ...style,
        }}
        min={min}
        step={step}
        autoComplete={autoComplete}
        {...(type === "number" && { onWheel: (e) => e.currentTarget.blur() })}
      ></input>
      {required && <p className="text-[13px] text-red-500">Required</p>}

      <div style={{ fontSize: "10px" }}>
        {<p className="text-red-500 mb-0 pb-0 h-[24px]">{error ? error : ""}</p>}
      </div>
    </div>
  );
};

export const PasswordInput = ({
  mandatory = false,
  required = false,
  placeholder,
  value,
  onChange = () => {},
  title,
  name,
  className,
  disabled = false,
  autoFocus,
  error,
  onBlur = () => {},
  style,
  preventCopyPasteCut = true,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const blockAction = (e) => {
    if (preventCopyPasteCut) {
      e.preventDefault();
      return false;
    }
  };
  return (
    <div className="relative">
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C] flex mb-1">
          {title} {mandatory && <span className="text-red-500">*</span>}
        </h3>
      )}

      <div className="relative">
        <input
          autoFocus={autoFocus}
          type={showPassword ? "text" : "password"}
          name={name}
          className={` pl-[11px] h-[38px] ${
            required ? "border-red-500" : ""
          } form-input p-1 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 pr-10 ${className}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          style={{
            ...(disabled && {
              cursor: "not-allowed",
              backgroundColor: "var(--input-disabled-bg)",
              color: "black",
            }),
            ...style,
          }}
          onCopy={blockAction}
          onCut={blockAction}
          onPaste={blockAction}
          onCopyCapture={blockAction}
          onCutCapture={blockAction}
          onPasteCapture={blockAction}
        />

        {/* Eye toggle button */}
        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          {showPassword ? (
            <EyeOff size={18} strokeWidth={1.5} />
          ) : (
            <Eye size={18} strokeWidth={1.5} />
          )}
        </button>
      </div>

      {required && <p className="text-[13px] text-red-500">Required</p>}
      <p style={{ opacity: error ? 1 : 0 }} className="text-[13px] text-red-500 mb-0 pb-0">
        {error || "null"}
      </p>
    </div>
  );
};
export const PhoneInput = ({
  mandatory = false,
  required = false,
  placeholder,
  value,
  onChange = () => {},
  title,
  name,
  className,
  disabled = false,
  autoFocus,
  error,
  onBlur = () => {},
  style,
  preventCopyPasteCut = true,
  onView = () => {},
  autoComplete = "off",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const blockAction = (e) => {
    if (preventCopyPasteCut) {
      e.preventDefault();
      return false;
    }
  };
  return (
    <div className="relative">
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C] flex mb-1">
          {title} {mandatory && <span className="text-red-500">*</span>}
        </h3>
      )}

      <div className="relative">
        <input
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          min={0}
          // type={showPassword ? "text" : "password"}
          type="text"
          name={name}
          className={` pl-[11px] h-[38px] ${
            required ? "border-red-500" : ""
          } form-input p-1 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 pr-10 ${className}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          style={{
            ...(disabled && {
              cursor: "not-allowed",
              backgroundColor: "var(--input-disabled-bg)",
              color: "black",
            }),
            ...style,
          }}
          onCopy={blockAction}
          onCut={blockAction}
          onPaste={blockAction}
          onCopyCapture={blockAction}
          onCutCapture={blockAction}
          onPasteCapture={blockAction}
        />

        {/* Eye toggle button */}
        <button
          type="button"
          // onClick={() => setShowPassword((prev) => !prev)}
          onClick={() => {
            setShowPassword((prev) => !prev);
            onView();
          }}
          className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          {showPassword ? (
            <EyeOff size={18} strokeWidth={1.5} />
          ) : (
            <Eye size={18} strokeWidth={1.5} />
          )}
        </button>
      </div>

      {required && <p className="text-[13px] text-red-500">Required</p>}
      <p style={{ opacity: error ? 1 : 0 }} className="text-[13px] text-red-500 mb-0 pb-0">
        {error || "null"}
      </p>
    </div>
  );
};

/**
 * Optimized Dropdown Component using Ant Design Select
 * Features: Notes, Error handling, Required validation, Better UX
 */
export const SelectInput = ({
  // Basic props
  placeholder = "Select option",
  options = [], // {value,label}
  optionsSorting = true,
  value,
  onChange = () => {}, // will return direct selected value

  // UI props
  title,
  note, // New feature for additional information
  size = "small", // small, middle, large

  // Validation props
  required = false,
  mandatory = false,
  error,
  disabled = false,

  // Functionality props
  allowClear = true,
  showSearch = false,
  mode = undefined, // "multiple" for multi-select, "tags" for tag mode
  maxTagCount = "responsive",

  // Styling props
  className = "",
  style = {},
  dropdownStyle = {},

  // Advanced props
  loading = false,
  notFoundContent = "No options available",
  filterOption = true, // Enable/disable search filtering
  showArrow = true,

  // Event handlers
  onSearch = undefined,
  onFocus = undefined,
  onBlur = undefined,
  onDropdownVisibleChange = undefined,
  searchValue,
  defaultValue,
  containerStyle = {},
  sortType = "default",
}) => {
  // Handle value changes
  // const [internalSearchValue, setSearchValue] = useState(searchValue);
  const handleChange = useCallback(
    (selectedValue) => {
      const selected_obj = options.find((option) => option.value === selectedValue);

      onChange(selectedValue, selected_obj);
    },
    [onChange]
  );
  // Handle search
  const handleSearch = useCallback(
    (searchValue) => {
      if (onSearch) {
        onSearch(searchValue);
      }
    },
    [onSearch]
  );

  // Filter options for search
  const filterOptions = useCallback(
    (inputValue, option) => {
      if (!filterOption) return true;

      const label = option?.label?.toString().toLowerCase() || "";
      const value = option?.value?.toString().toLowerCase() || "";
      const input = inputValue.toLowerCase();

      return label.includes(input) || value.includes(input);
    },
    [filterOption]
  );

  // Memoize options to prevent unnecessary re-renders
  const memoizedOptions = useMemo(() => {
    let op = options.map((option) => ({
      label: option.label || option.value,
      value: option.value,
      disabled: option.disabled || false,
      ...option,
    }));
    if (optionsSorting) {
      // First, sort all options normally
      op = universalSortForObjectsArray({ data: op, key: "label", sortOption: sortType });

      // Then, move options containing "other" to the end
      const otherOptions = op.filter(
        (option) => option.value && option.value.toLowerCase().includes("other")
      );
      const nonOtherOptions = op.filter(
        (option) => !option.value || !option.value.toLowerCase().includes("other")
      );
      // Combine non-other options first, then other options
      op = [...nonOtherOptions, ...otherOptions];
    }
    return op;
  }, [options]);

  // Get current value for display
  const currentValue = useMemo(() => {
    if (!value) return undefined;

    if (mode === "multiple" || mode === "tags") {
      return Array.isArray(value) ? value : [value];
    }

    return value;
  }, [value, mode]);

  // Check if field has error
  const hasError = Boolean(error);
  const isRequired = required;

  return (
    <div style={{ ...containerStyle }} className={`ant-select-input-wrapper `}>
      {/* Title with mandatory indicator */}
      {title && (
        <div className="flex items-center gap-0 ">
          <h3 className="text-[13px] font-publicSans text-[#4B465C]">{title}</h3>
          {mandatory && <span className="text-sm p-0 m-0"> *</span>}
        </div>
      )}

      {/* Note section */}
      {note && (
        <div className="mb-2">
          <p className="text-[12px] text-gray-500 italic">{note}</p>
        </div>
      )}

      {/* Ant Design Select */}
      <AntSelect
        // Basic props
        //   mode="tags"
        // filterSort
        // listHeight
        placeholder={placeholder}
        value={currentValue}
        onChange={handleChange}
        options={memoizedOptions}
        // UI props
        size={size}
        disabled={disabled}
        loading={loading}
        // Functionality props
        allowClear={allowClear}
        showSearch={showSearch}
        mode={mode}
        maxTagCount={maxTagCount}
        defaultValue={defaultValue}
        // showArrow={showArrow}

        // Styling
        // className={`w-full  ${className}`}
        // className={`
        //     w-full
        //     [&>.ant-select-selector]:!h-[38px]  // reduce height
        //     [&>.ant-select-selector]:!py-0  // remove vertical padding
        //     [&>.ant-select-selector]:!flex
        //     [&>.ant-select-selector]:!items-center
        //     ${className}
        //   `}
        className={`custom-antd-select   ${className}`}
        dropdownStyle={{ ...dropdownStyle }}
        // Search and filtering
        onSearch={handleSearch}
        filterOption={filterOptions}
        notFoundContent={notFoundContent}
        // Event handlers
        onFocus={onFocus}
        onBlur={onBlur}
        onDropdownVisibleChange={onDropdownVisibleChange}
        // Custom styles
        style={{
          borderRadius: "18px",
          ...style,

          ...(hasError && { borderColor: "#ff4d4f" }),
        }}
        status={hasError ? "error" : undefined}
      />

      {/* Required field indicator */}
      {isRequired && !value && <p className="text-[13px] text-red-500">This field is required</p>}

      {/* Error message */}
      {
        <p style={{ opacity: error ? 1 : 0 }} className="text-[13px] text-red-500 mb-0 pb-0">
          {error ? error : "null"}
        </p>
      }
    </div>
  );
};

/**
 * Utility function to create options array from simple arrays
 * @param {Array} array - Array of strings or objects
 * @param {string} labelKey - Key for label (default: 'label')
 * @param {string} valueKey - Key for value (default: 'value')
 * @returns {Array} Formatted options array
 */
export const createOptionsFromArray = (array, labelKey = "label", valueKey = "value") => {
  if (!Array.isArray(array)) return [];

  return array.map((item, index) => {
    if (typeof item === "string") {
      return { label: item, value: item };
    }
    if (typeof item === "object") {
      return {
        label: item[labelKey] || item.value || item.name || `Option ${index + 1}`,
        value: item[valueKey] || item.id || item.key || index,
        ...item,
      };
    }
    return { label: `Option ${index + 1}`, value: index };
  });
};

/**
 * Utility function to validate required fields
 * @param {any} value - Field value
 * @param {boolean} required - Is field required
 * @returns {string|null} Error message or null
 */
export const validateRequired = (value, required) => {
  if (!required) return null;

  if (value === null || value === undefined || value === "") {
    return "This field is required";
  }

  if (Array.isArray(value) && value.length === 0) {
    return "Please select at least one option";
  }

  return null;
};

export const ReusableDropdown = ({
  options = [],
  placeholder = "Select option",
  onSelect = () => {},
  inputPlaceholder = "Search...",
  dropdownWidth = 200,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [selected, setSelected] = useState(null);

  // Filter options based on input
  const filteredOptions = options.filter((item) =>
    item.label.toLowerCase().includes(searchValue.toLowerCase())
  );

  // Build dropdown menu
  const menu = (
    <div className="p-2" style={{ width: dropdownWidth }}>
      <AntdInput
        placeholder={inputPlaceholder}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        className="mb-2"
      />
      <Menu
        items={filteredOptions.map((item) => ({
          key: item.value,
          label: (
            <div
              onClick={() => {
                setSelected(item);
                onSelect(item);
              }}
            >
              {item.label}
            </div>
          ),
        }))}
      />
    </div>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <div className="flex items-center justify-between px-3 py-2 border rounded-lg cursor-pointer">
        <span>{selected ? selected.label : placeholder}</span>
        <DownOutlined />
      </div>
    </Dropdown>
  );
};

export const InputDropdown = ({
  options = [], // {label:string,value:string}
  placeholder = "Type or select...",
  onChange = () => {},
  dropdownWidth = 250,
  optionsSorting = true,
  disabled,
  title,
  mandatory = false,
  error,
  autoFocus = false,
  type = "text",
  name,
  className,
  min,
  step,
  required = false,
  value,
  // type='text'
  useInternalInputSearch = true,
  // min
  sortType = "default",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const internal_options = useMemo(() => {
    let op = options.map((item) => {
      return { label: item.label, value: item.value };
    });
    if (optionsSorting) {
      op = universalSortForObjectsArray({ data: op, key: "label", sortOption: sortType });
    }
    return op;
  }, [options]);

  // Filter options based on input
  const filteredOptions = internal_options.filter((item) => {
    const searchVal = String(inputValue || "").toLowerCase(); // ✅ always a string
    return item?.label?.toLowerCase()?.includes(searchVal);
  });

  // Dropdown menu
  const menu = (
    <div
      style={{
        maxHeight: 200,
        overflowY: "auto",
        width: "100%",
        background: "#fff",
        border: "1px solid #f0f0f0",
        borderRadius: 6,
      }}
      className="custom-scrollbar"
    >
      {filteredOptions.length > 0 ? (
        filteredOptions.map((item) => (
          <div
            key={item.value}
            className="px-3 py-2 cursor-pointer hover:bg-gray-100"
            onClick={() => {
              setInputValue(item.label);
              onChange(item?.value); // trigger on selecting option
              setOpen(false);
            }}
          >
            {item.label}
          </div>
        ))
      ) : (
        <div className="px-3 py-2 text-gray-400">No options found</div>
      )}
    </div>
  );

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      dropdownRender={() => menu}
      trigger={["click"]}
      disabled={disabled}
    >
      <Input
        min={min}
        step={step}
        error={error}
        type={type}
        title={title}
        placeholder={placeholder}
        disabled={disabled}
        value={inputValue}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          if (useInternalInputSearch) {
            setInputValue(e.target.value);
            onChange(e.target.value); // trigger on typing
          } else {
            onChange(e.target.value); // trigger on typing
          }
          if (!open) setOpen(true);
        }}
      />
    </Dropdown>
  );
};

export const InputTextArea = ({
  disabled,
  allTimeEditMode,
  oneTimeEditMode,
  rows = 6,
  mandatory = false,
  required = false,
  placeholder,
  value,
  updatedValue,
  onChange = () => {},
  title,
  name,
  className,
  style,
}) => {
  return (
    <div>
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C]  flex">
          {title}
          {mandatory && <span className="p-0 m-0 text-sm">*</span>}
        </h3>
      )}
      <textarea
        name={name}
        rows={rows}
        cols={2}
        style={{
          ...style,
          ...(disabled && {
            cursor: "not-allowed",
            backgroundColor: "var(--input-disabled-bg)",
            color: "black",
          }),
        }}
        className={`pl-[11px] ${
          required ? "border-red-500" : ""
        } form-input p-2 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      ></textarea>
      {required && <p className="text-[13px] text-red-500">Required</p>}
    </div>
  );
};

export const IncrementDecrementInput = ({
  value = 0,
  onChange = () => {},
  disabled = false,
  min = 0,
}) => {
  const handleDecrement = () => {
    const count = parseInt(value || 0);
    if (count > min) {
      onChange(count - 1);
    } else {
      onChange(min);
    }
  };

  const handleIncrement = () => {
    const count = parseInt(value || 0);
    onChange(count + 1);
  };

  const handleInput = (e) => {
    onChange(Number(e.target.value));
  };

  //
  return (
    <div
      className={`flex items-center rounded-[6px] border-[1px] mt-[2px] ${
        disabled
          ? "border-[#dedede] hover:border-[#dedede]"
          : "border-[#dedede] hover:border-[#000000]"
      }`}
      style={{
        maxHeight: "38px",
        ...(disabled && {
          cursor: "not-allowed",
          backgroundColor: "var(--input-disabled-bg)",
          color: "black",
        }),
      }}
    >
      <div>
        <button
          type="button"
          disabled={disabled}
          onClick={handleDecrement}
          className={` px-2 h-[38px] text-lg font-semibold transition-colors duration-150 ${
            disabled
              ? "text-[#AAAAAA] font-dm-sans-nocolor-400"
              : "text-[#616161] hover:text-[#616161]"
          }`}
        >
          −
        </button>
      </div>

      <div style={{ maxHeight: "38px" }} className="">
        <Input
          type=""
          min={min}
          value={value}
          onChange={handleInput}
          style={{
            textAlign: "center",
            maxHeight: "35px",
            marginBottom: "2px",
            border: "none",
            ...(disabled && {
              cursor: "not-allowed",
              backgroundColor: "var(--input-disabled-bg)",
              color: "black",
            }),
          }}
          disabled={disabled}
          className="px-auto font-semibold transition-colors duration-150 input-value-dm-400"
        />
      </div>

      <div>
        {" "}
        <button
          type="button"
          disabled={disabled}
          onClick={handleIncrement}
          className={`px-2 h-[38px] text-lg font-semibold transition-colors duration-150 ${
            disabled ? "text-[#AAAAAA]" : "text-[#4B465C] hover:text-[#4B465C]"
          }`}
        >
          +
        </button>
      </div>
    </div>
  );
};

export const MultiSelectInput = ({
  options = [], // {label:string,value:string}
  checkbox = false,
  allowDeselect = true,
  search = false,
  tags = true,
  value = [],
  onChange = () => {},
  placeholder = "Select options...",
  theme = "default",
  className = "",
  containerStyle = {},
}) => {
  const [internalOptions, setInternalOptions] = useState(options);
  useEffect(() => {
    handleOptions(options);
  }, [options]);
  const handleOptions = (options) => {
    const op = [...options];
    setInternalOptions(op);
    return op;
  };
  // Custom tag render for scrollable tags
  const tagRender = (props) => {
    const { label, closable, onClose } = props;

    const getLabelText = (label) => {
      if (typeof label === "string") return label; // plain string
      if (React.isValidElement(label)) {
        // if it's a React element with children
        if (typeof label.props.children === "string") {
          return label.props.children;
        }
        // fallback: convert children array to string
        if (Array.isArray(label.props.children)) {
          return label.props.children.join(" ");
        }
      }
      return String(label); // fallback
    };

    return (
      <Tag
        closable={closable && allowDeselect}
        onClose={onClose}
        style={{
          marginRight: 3,
          maxWidth: 120,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
        className="custom-tag [&>.ant-tag-close-icon]:text-[10px] [&>.ant-tag-close-icon]:w-[10px] [&>.ant-tag-close-icon]:h-[10px] "
      >
        {getLabelText(label)}
      </Tag>
    );
  };

  return (
    <div
      className="w-full"
      style={{ height: "38px", borderRadius: "6px", width: "100%", ...containerStyle }}
    >
      <AntSelect
        mode="multiple" // tags
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        tagRender={tags ? tagRender : () => null} //  tagRender={() => null} // ❌ completely hides tags
        showSearch={search} // If tags disabled, use input as search
        open={undefined}
        className={classNames(
          `custom-antd-select custom-antd-multi-select [&>.ant-select-selection-placeholder]:!text-black  w-full ${className}`,
          {
            "overflow-x-auto whitespace-nowrap": value?.length > 3, // scroll tags if overflow
          }
        )}
        allowClear={allowDeselect}
        maxTagCount={"responsive"} // 0 to hide all tags,responsive to show scrollbar
        // options={internalOptions}
        // optionFilterProp="label"
        // filterOption={(input, option) =>
        //     (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        // }
        // filterSort={(optionA, optionB) =>
        //     (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
        // }
        // notFoundContent={null}
        // onSearch={handleSearch}
        // suffixIcon={null}
        // tokenSeparators={[',']}
        // prefix="User"
        // defaultValue="lucy"
        // suffixIcon={smileIcon}
        styles={{
          height: "12px !important",
          backgroundColor: "red !important",
        }}
      >
        {options.map((opt) => (
          <AntSelect.Option key={opt.value} value={opt.value}>
            {checkbox ? (
              <Checkbox checked={value?.includes(opt.value)}>{opt.label}</Checkbox>
            ) : (
              opt.label
            )}
          </AntSelect.Option>
        ))}
      </AntSelect>
    </div>
  );
};

export const InputRadioButtonGroup = ({
  title,
  mandatory = false, // true or false
  options = [], // [{ label: "Option 1", value: "opt1" }]
  selectedValue,
  onChange = () => {},
  shape = "rounded", // "rounded" | "square"
  labelStyle = {},
  containerStyle = {},
  titleStyle = {},
  name = "radio-group",
  checkboxstyle = {},
  disabled = false,
}) => {
  const isRounded = shape === "rounded";

  const handleClick = (optionValue) => {
    // toggle: if same option clicked again -> unselect
    if (selectedValue === optionValue) {
      onChange(null); // deselect
    } else {
      onChange(optionValue); // select new option
    }
  };
  return (
    <div style={{ ...containerStyle }}>
      {title && (
        <h3 style={{ ...titleStyle }} className="text-[13px] font-publicSans text-[#4B465C]  flex">
          {title} {mandatory && <span className="text-red-500">*</span>}
        </h3>
      )}
      <div className="flex flex-wrap gap-3">
        {options.map((option) => {
          const id = `${name}-${option.value}`;

          return (
            <div key={option.value} className="flex items-center gap-2">
              <input
                id={id}
                type="radio"
                name={name}
                value={option.value}
                checked={selectedValue === option.value}
                // onChange={(e) => onChange(e)}
                className="hidden"
                readOnly // for prevent change value from input
                disabled={disabled}
              />

              <label
                onClick={() => {
                  if (disabled) {
                    return;
                  }
                  handleClick(option.value);
                }}
                style={{
                  ...checkboxstyle,
                  borderWidth: "1.5px",
                  ...(isRounded && {
                    borderRadius: "50%",
                  }),
                  ...(!isRounded && { fontSize: "13px", borderRadius: "5px" }),
                  ...(selectedValue === option.value && {
                    backgroundColor: isRounded ? "white" : "#4319ff",
                    borderColor: "#4319ff",
                    borderWidth: isRounded ? "2px" : "",
                    color: "white",
                  }),
                  ...(selectedValue !== option.value && {
                    backgroundColor: "white",
                    borderColor: "#dfdfdf",
                  }),
                }}
                htmlFor={id}
                className={`flex items-center ${disabled ? "pointer-events-none cursor-not-allowed" : "cursor-pointer"} justify-center select-none border w-4 h-4 transition-all duration-200
                  ${selectedValue === option.value ? "" : "hover:border-blue-400"}
                `}
              >
                {!isRounded && selectedValue === option.value ? "✓" : ""}
                {isRounded && selectedValue === option.value && (
                  <span
                    disabled={disabled}
                    style={{ borderRadius: "50%" }}
                    className={`w-2 h-2 bg-[#4319ff]`}
                  ></span>
                )}
              </label>

              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  color: "rgb(75, 70, 92)",
                  ...labelStyle,
                }}
              >
                {option.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// export const TimeInput = ({ value = "", onChange, title = "", disabled = false }) => {
//   const [time, setTime] = useState({ h: "", m: "", s: "" });

//   // Parse default value
//   useEffect(() => {
//     if (value) {
//       const [h = "", m = "", s = ""] = value.split(":");
//       setTime({ h, m, s });
//     }
//   }, [value]);

//   // Handle change for each field
//   const handleChange = (field, val) => {
//     if (val === "" || /^[0-9\b]+$/.test(val)) {
//       let newTime = { ...time, [field]: val };

//       // Format and send to parent
//       const formatted = [
//         newTime.h.padStart(2, "0") || "00",
//         newTime.m.padStart(2, "0") || "00",
//         newTime.s.padStart(2, "0") || "00",
//       ].join(":");

//       setTime(newTime);
//       onChange?.(formatted);
//     }
//   };

//   // Auto-fix invalid values (e.g., >59)
//   const validateRange = (field, val) => {
//     let num = parseInt(val || "0", 10);
//     if (field === "h" && num > 23) num = 23;
//     if ((field === "m" || field === "s") && num > 59) num = 59;
//     handleChange(field, num.toString());
//   };

//   return (
//     <div style={{ maxWidth: "100%", maxHeight: "100%" }} className=" flex flex-col items-start ">
//       {fieldContainsValue(title) && (
//         <p
//           style={{ marginBottom: "0px", padding: "0px" }}
//           className="text-[13px] font-publicSans text-[#4B465C]  flex  flex items-center justify-between"
//         >
//           {title}
//         </p>
//       )}
//       <div
//         style={{
//           height: "38px",
//           borderRadius: "6px",
//           borderStyle: "solid",
//           borderWidth: "1px",
//           width: "100%",
//         }}
//         className={`flex items-center justify-evenly  py-[2px] px-[1px] border-gray-300`}
//       >
//         {/* Hours */}
//         <input
//           type="text"
//           value={time.h}
//           onChange={(e) => handleChange("h", e.target.value)}
//           onBlur={() => validateRange("h", time.h)}
//           placeholder="HH"
//           maxLength={2}
//           disabled={disabled}
//           // className="text-center border rounded-lg p-1  outline-none disabled:bg-gray-100"
//           style={{
//             maxWidth: "40px",
//             width: "26%",
//             textAlign: "center",
//             outline: "none",
//             height: "100%",
//             backgroundColor: "transparent",
//             ...(disabled && {
//               cursor: "not-allowed",
//               color: "black",
//             }),
//           }}
//           className="text-gray-600"
//         />
//         <span style={{ width: "10%", textAlign: "center" }}>:</span>

//         {/* Minutes */}
//         <input
//           type="text"
//           value={time.m}
//           onChange={(e) => handleChange("m", e.target.value)}
//           onBlur={() => validateRange("m", time.m)}
//           placeholder="MM"
//           maxLength={2}
//           disabled={disabled}
//           // className="w-14 text-center border rounded-lg p-1  outline-none disabled:bg-gray-100"
//           style={{
//             maxWidth: "40px",
//             width: "26%",
//             textAlign: "center",
//             outline: "none",
//             height: "100%",
//             backgroundColor: "transparent",
//             ...(disabled && {
//               cursor: "not-allowed",
//               color: "black",
//             }),
//           }}
//           className="text-gray-600"
//         />
//         <span style={{ width: "10%", textAlign: "center" }}>:</span>

//         {/* Seconds */}
//         <input
//           type="text"
//           value={time.s}
//           onChange={(e) => handleChange("s", e.target.value)}
//           onBlur={() => validateRange("s", time.s)}
//           placeholder="SS"
//           maxLength={2}
//           disabled={disabled}
//           // className="w-14 text-center border rounded-lg p-1  outline-none disabled:bg-gray-100"
//           style={{
//             maxWidth: "40px",
//             width: "26%",
//             textAlign: "center",
//             outline: "none",
//             height: "100%",
//             backgroundColor: "transparent",
//             backgroundColor: "transparent",
//             ...(disabled && {
//               cursor: "not-allowed",
//               color: "black",
//             }),
//           }}
//           className="text-gray-600"
//         />
//       </div>
//     </div>
//   );
// };

export const TimeInput = ({
  value = "",
  onChange,
  title = "",
  disabled = false,
  use12Hour = true,
  mandatory = false,
  min = null, // expected format: "HH:mm:ss" or "hh:mm:ss A"
}) => {
  const format = use12Hour ? "hh:mm:ss A" : "HH:mm:ss";

  // Convert incoming parent value → dayjs
  const parseValue = (val) => {
    if (!val) return null;
    return dayjs(val, format);
  };

  // Convert min time → dayjs
  const minTimeObj = min ? dayjs(min, format) : null;

  // Disable times below minimum
  const disabledHours = () => {
    if (!minTimeObj) return [];
    const minHour = minTimeObj.hour();
    return Array.from({ length: minHour }, (_, i) => i); // disable 0 → minHour-1
  };

  const disabledMinutes = (hour) => {
    if (!minTimeObj) return [];
    if (hour !== minTimeObj.hour()) return [];
    return Array.from({ length: minTimeObj.minute() }, (_, i) => i);
  };

  const disabledSeconds = (hour, minute) => {
    if (!minTimeObj) return [];
    if (hour !== minTimeObj.hour()) return [];
    if (minute !== minTimeObj.minute()) return [];
    return Array.from({ length: minTimeObj.second() }, (_, i) => i);
  };

  const handleChange = (timeObj) => {
    if (!timeObj) {
      onChange?.("");
      return;
    }
    onChange?.(timeObj.format(format)); // return formatted value
  };

  return (
    <div style={{ width: "100%" }}>
      {title && (
        <p className="text-[13px] font-publicSans text-[#4B465C] m-0">
          {title}
          {mandatory && <span className="text-sm">*</span>}
        </p>
      )}

      <TimePicker
        value={parseValue(value)}
        format={format}
        onChange={handleChange}
        use12Hours={use12Hour}
        // disabled={disabled}
        allowClear={false}
        style={{
          width: "100%",
          marginTop: "4px",
        }}
        disabledHours={disabledHours}
        disabledMinutes={disabledMinutes}
        disabledSeconds={disabledSeconds}
      />
    </div>
  );
};

export const DateTimePicker = ({
  value = "",
  onChange,
  title = "",
  disabled = false,
  mandatory = false,
  use12Hour = true,
  min = null, // "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DD hh:mm:ss A"
  max = null, // optional max
  className,
  required = false,
  titleSvgType,
  onTitleSvgClick = () => {},
  titleSvgSize = 15,
  placeholder = "Select date and time",
  style = {},
  isRequired,
  error,
}) => {
  const format = use12Hour ? "YYYY-MM-DD hh:mm:ss A" : "YYYY-MM-DD HH:mm:ss";

  const parseValue = (val) => {
    if (!val) return null;
    return dayjs(val, format);
  };

  const minObj = min ? dayjs(min, format) : null;
  const maxObj = max ? dayjs(max, format) : null;

  // Disable dates outside min/max
  const disabledDate = (current) => {
    if (!current) return false;
    if (minObj && current.isBefore(minObj, "day")) return true;
    if (maxObj && current.isAfter(maxObj, "day")) return true;
    return false;
  };

  // Disable times on min/max date
  const disabledTime = (current) => {
    if (!current) return {};

    const disabled = {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };

    // Min time restriction (same day)
    if (minObj && current.isSame(minObj, "day")) {
      const minHour = minObj.hour();
      const minMinute = minObj.minute();
      const minSecond = minObj.second();

      disabled.disabledHours = () => Array.from({ length: minHour }, (_, i) => i);

      disabled.disabledMinutes = (h) =>
        h === minHour ? Array.from({ length: minMinute }, (_, i) => i) : [];

      disabled.disabledSeconds = (h, m) =>
        h === minHour && m === minMinute ? Array.from({ length: minSecond }, (_, i) => i) : [];
    }

    // Max time restriction (same day)
    if (maxObj && current.isSame(maxObj, "day")) {
      const maxHour = maxObj.hour();
      const maxMinute = maxObj.minute();
      const maxSecond = maxObj.second();

      disabled.disabledHours = () => [
        ...disabled.disabledHours(),
        ...Array.from({ length: 24 - (maxHour + 1) }, (_, i) => maxHour + 1 + i),
      ];

      disabled.disabledMinutes = (h) =>
        h === maxHour
          ? [
              ...disabled.disabledMinutes(h),
              ...Array.from({ length: 60 - (maxMinute + 1) }, (_, i) => maxMinute + 1 + i),
            ]
          : [];

      disabled.disabledSeconds = (h, m) =>
        h === maxHour && m === maxMinute
          ? Array.from({ length: 60 - (maxSecond + 1) }, (_, i) => maxSecond + 1 + i)
          : [];
    }

    return disabled;
  };

  const handleChange = (datetime) => {
    if (!datetime) return onChange?.("");
    onChange?.(datetime.format(format));
  };

  return (
    <div style={{ width: "100%" }}>
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C]  flex  flex items-center justify-between gap-0">
          <span>
            {title}
            {mandatory && <span className="p-0 m-0 text-sm">*</span>}
          </span>
          {titleSvgType && (
            <span
              style={{
                ...(onTitleSvgClick && {
                  cursor: "pointer",
                }),
              }}
              onClick={() => {
                if (onTitleSvgClick) {
                  onTitleSvgClick?.();
                }
              }}
            >
              <SvgIcon size={titleSvgSize} type={titleSvgType} />
            </span>
          )}
        </h3>
      )}

      <DatePicker
        value={parseValue(value)}
        format={format}
        onChange={handleChange}
        disabled={disabled}
        disabledDate={disabledDate}
        disabledTime={disabledTime}
        showTime={{
          use12Hours: use12Hour,
          format: use12Hour ? "hh:mm:ss A" : "HH:mm:ss",
        }}
        placeholder={placeholder}
        allowClear={false}
        style={{
          ...(disabled && {
            cursor: "not-allowed",
            backgroundColor: "var(--input-disabled-bg)",
            color: "black",
          }),
          ...style,
        }}
        className={`custom-antd-date-picker pl-[11px] h-[38px] ${
          required ? "border-red-500" : ""
        } form-input p-1 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 ${className}`}
      />
      {/* Required field indicator */}
      {required && <p className="text-[13px] text-red-500">Required</p>}
      {
        <p style={{ opacity: error ? 1 : 0 }} className="text-[13px] text-red-500 mb-0 pb-0">
          {error ? error : "null"}
        </p>
      }
    </div>
  );
};
